<template>
    <div class="hello m-1" id="hello_reputation_global_risk" ref="chartdiv"></div>
</template>

<script>
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
/* eslint-disable */
import globalVar from "@/assets/globalVar.json"

export default {
  data() {
    return {
      selectedCountry: { id: '', value: '' },
      status: null
    }
  },
  props: {
    data_country: {
        type: Object,
        required: true,
    },
  },
  methods: {
    getStatusClass(status) {
      let rangesData = globalVar.risk
      if (status < rangesData[0].rangeMax) {
        return `color: ${rangesData[0].color}`
      } else if (status >= rangesData[1].rangeMin - 0.005  && status < rangesData[1].rangeMax - 0.005) {
        return `color: ${rangesData[1].color}`
      } else if (status >= rangesData[2].rangeMin - 0.005  && status < rangesData[2].rangeMax - 0.005) {
        return `color: ${rangesData[2].color}`
      } else if (status >= rangesData[3].rangeMin - 0.005  && status < rangesData[3].rangeMax - 0.005) {
        return `color: ${rangesData[3].color}`
      } else {
        return `color: ${rangesData[4].color}`
      }
    },
    GetCountry() {
        this.selectedCountry.id = this.data_country.name;
        this.selectedCountry.value = this.data_country.reputationalRisk;
        this.selectedCountry.value_str = this.data_country.reputationalRisk !== null ? Math.round(this.data_country.reputationalRisk * 100) / 100 : '';
    },
    renderChart() {
      let root = am5.Root.new(this.$refs.chartdiv);
      root.setThemes([
        am5themes_Animated.new(root)
      ]);
      let chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        dx: 60,
        dy: -15,
        layout: root.verticalLayout,
      }));
      let legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.p50,
          x: am5.p50
        })
      );

      let yAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: am5xy.AxisRendererY.new(root, {}),
        tooltip: am5.Tooltip.new(root, {})
      }));

      let yRenderer = yAxis.get("renderer");

      yRenderer.grid.template.set("forceHidden", true);
      yRenderer.labels.template.set("forceHidden", true);
      let rangesData = globalVar.risk
      let data = [
      {
        category: "1",
        value: 100,
        risk: this.selectedCountry.value_str,
        currentBullet: false,
        columnSettings: {
          fill: am5.color(this.selectedCountry.value_str !== '' ? rangesData[0].color : '#999999')
        }
      }, {
        category: "2",
        value: 100,
        risk: this.selectedCountry.value_str,
        currentBullet: false,
        columnSettings: {
          fill: am5.color(this.selectedCountry.value_str !== '' ? rangesData[1].color : '#999999')
        }
      }, {
        category: "3",
        value: 100,
        risk: this.selectedCountry.value_str,
        currentBullet: false,
        columnSettings: {
          fill: am5.color(this.selectedCountry.value_str !== '' ? rangesData[2].color : '#999999')
        }
      }, {
        category: "4",
        value: 100,
        risk: this.selectedCountry.value_str,
        currentBullet: false,
        columnSettings: {
          fill: am5.color(this.selectedCountry.value_str !== '' ? rangesData[3].color : '#999999')
        }
      }, {
        category: "5",
        value: 100,
        risk: this.selectedCountry.value_str,
        currentBullet: false,
        columnSettings: {
          fill: am5.color(this.selectedCountry.value_str !== '' ? rangesData[4].color : '#999999')
        } 
      }
    ];

    let category = 1;
    if (this.selectedCountry.value >= 5) {
      category = 5;
      this.status = rangesData[4].indicator;
    } else {
      category = '#808080'
      for (let i = 0; i < rangesData.length; i++) {
        if(this.selectedCountry.value >= rangesData[i].rangeMin && this.selectedCountry.value <= rangesData[i].rangeMax){
          category = i+1;
          this.status = rangesData[i].indicator;
          break;
        }
      }
    }
    data.forEach(item => {
      item.currentBullet = item.category == category;
    });
    yAxis.data.setAll(data);

    let xAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      min: 0,
      max: 400,
      strictMinMax: true,
      renderer: am5xy.AxisRendererX.new(root, {})
    }));

    let xRenderer = xAxis.get("renderer");

    xRenderer.grid.template.set("forceHidden", true);
    xRenderer.labels.template.set("forceHidden", true);

    let series = chart.series.push(am5xy.ColumnSeries.new(root, {
      xAxis: xAxis,
      yAxis: yAxis,
      valueXField: "value",
      categoryYField: "category",
      riskYField: "risk",
      maskBullets: false,
      
    }));

      // chart.children.unshift(am5.Label.new(root, {
      //   text: "Risk Assessment",
      //   fontSize: 25,
      //   fontWeight: "500",
      //   textAlign: "center",
      //   x: am5.percent(50),
      //   centerX: am5.percent(50),
      //   paddingTop: 0,
      //   paddingBottom: 0
      // }));

      series.columns.template.setAll({
        width: 20,
        height: 70,
        tooltipY: 0,
        strokeOpacity: 1,
        strokeWidth:2,
        stroke:am5.color(0xffffff),
        templateField: "columnSettings"
      });

      series.bullets.push((root, target, dataItem) => {
        if (dataItem.dataContext.currentBullet) {
          if (this.selectedCountry.value_str !== '') {
            let container = am5.Container.new(root, {
              rotation: 90,
              dx: -20
            });

            let pin = container.children.push(am5.Graphics.new(root, {
              fill: dataItem.dataContext.columnSettings.fill,
              dy: -5,
              dx: 35,
              rotation: 180,
              centerY: am5.p100,
              centerX: am5.p50,
              svgPath: "M66.9 41.8c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4 0 11.3 20.4 32.4 20.4 32.4s20.4-21.1 20.4-32.4zM37 41.4c0-5.2 4.3-9.5 9.5-9.5s9.5 4.2 9.5 9.5c0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.3-9.5-9.5z"
            }));
            let textColor = am5.color("#ffffff");
            if (dataItem.dataContext.category == 5 || dataItem.dataContext.category == 4) {
              textColor = am5.color("#000000");
            }
            let label = container.children.push(am5.Label.new(root, {
              text: dataItem.dataContext.risk,
              rotation: -90,
              dy: 27,
              dx: 35,
              centerY: am5.p50,
              centerX: am5.p50,
              populateText: true,
              paddingTop: 6,
              paddingRight: 6,
              paddingBottom: 6,
              paddingLeft: 6,
              fill: textColor,
              background: am5.RoundedRectangle.new(root, {
                fill: dataItem.dataContext.columnSettings.fill,
                cornerRadiusTL: 20,
                cornerRadiusTR: 20,
                cornerRadiusBR: 20,
                cornerRadiusBL: 20,
              })
            }));

            return am5.Bullet.new(root, {
              locationY: 1,
              sprite: container
            });
          }
        } else if (dataItem.dataContext.targetBullet) {
          let container = am5.Container.new(root, {
            dx: 15
          });
          return am5.Bullet.new(root, {
            locationY: 0.5,
            sprite: container
          });
        }
        return false;
      });

      series.data.setAll(data);

      chart.children.unshift(am5.Label.new(root, {
        text: "Negligible Risk",
        fontSize: 15,
        fontWeight: "500",
        textAlign: "center",
        x: am5.percent(5),
        y: am5.percent(101),
        paddingTop: 0,
        paddingBottom: 0
      }));

      // Add label at the top
      chart.children.unshift(am5.Label.new(root, {
        text: "Severe Risk",
        fontSize: 15,
        fontWeight: "500",
        x: am5.percent(-30),
        y: am5.percent(2),
        paddingTop: 0,
        paddingBottom: 0
      }));

      // chart.children.unshift(am5.Label.new(root, {
      //   text: "Global Reputation Risk Assessment",
      //   fontSize: 25,
      //   fontWeight: "500",
      //   textAlign: "center",
      //   x: am5.percent(50),
      //   centerX: am5.percent(50),
      //   paddingTop: 0,
      //   paddingBottom: 0
      // }));

    series.appear(1000, 100);
    chart.appear(1000, 100);
    }
  },
  mounted() {
    this.GetCountry()
    this.renderChart()
  }
}
</script>